import { useTranslation } from 'react-i18next';
import travolta from 'src/images/other/travolta.webp';

export const UsersEmptyOrError = ({ isError }: { isError: boolean }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className='relative h-32 w-32'>
        <img
          src={travolta}
          width='100%'
          height='100%'
          alt='Travolta Sticker'
          className='absolute'
        />
      </div>
      {isError ? (
        <>
          <h2 className='pb-2 pt-4 text-center text-xl font-bold xs:text-2xl'>
            {t('history.something_went_wrong')}
          </h2>
          <h4 className='text-center font-secondary'>
            {t('common.please_try_again')}
          </h4>
        </>
      ) : (
        <>
          <h2 className='pb-2 pt-4 text-center text-xl font-bold xs:text-2xl'>
            No Users Found
          </h2>
          <h4 className='text-center font-secondary'>
            Try altering your search terms or filters.
          </h4>
        </>
      )}
    </>
  );
};
